import { RequiredAccess } from '../client-data-types/publication'

interface AccessLevels<SubscriberType, RegisteredType, AnonymousType> {
    subscriber?: SubscriberType
    registered?: RegisteredType
    anonymous: AnonymousType
}

/**
 * Return a different result for each level of requiredAccess, falling back to anonymous if the level is not defined.
 * @param requiredAccess
 * @param options
 */
export function requiredAccessValue<
    SubscriberType = never,
    RegisteredType = never,
    AnonymousType = never,
>(
    requiredAccess: RequiredAccess | undefined,
    options: AccessLevels<SubscriberType, RegisteredType, AnonymousType>,
): SubscriberType | RegisteredType | AnonymousType {
    if (!requiredAccess) {
        return options.anonymous
    }
    return options[requiredAccess.level] ?? options.anonymous
}
